import React from 'react';


interface Props {

}

export const FormItem = (props: React.PropsWithChildren<Props>) => {
    return (
        <div className='form-item'>
                {props.children}
        </div>
    );
};